import axios, { AxiosResponse } from "axios";
import { DataResponse, IValueLabel } from "utils/commonModels";
import {
  AreaDataModel,
  CategoryDataModel,
  ICategoryRequest,
  ICountModel,
  IDistrictData,
  IKeywordRequest,
  IKeywordSuggest,
} from "./models";

const HOMEPAGE_API =
  "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/list-entity";

export const homepageApi = {
  getArea(top: number): Promise<AxiosResponse<AreaDataModel[]>> {
    const req: ICategoryRequest = {
      sort_code: 0,
      top_n: top,
      entity_code: 1,
    };
    const url = HOMEPAGE_API;
    return axios.post(url, req);
  },
  getCount(): Promise<AxiosResponse<DataResponse<ICountModel>>> {
    const url =
      "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/screen1/count";
    return axios.get(url);
  },
  getSuggets(
    req: IKeywordRequest
  ): Promise<AxiosResponse<DataResponse<IValueLabel<string>[]>>> {
    const url =
      "https://bzzz17duba.execute-api.ap-northeast-1.amazonaws.com/phase1/search/suggest";
    return axios.post(url, req);
  },
  getDistrict(top: number): Promise<AxiosResponse<IDistrictData>> {
    const req: ICategoryRequest = {
      sort_code: 0,
      top_n: top,
      entity_code: 1,
    };
    const url = HOMEPAGE_API;
    return axios.post(url, req);
  },
  getGenres(top: number): Promise<AxiosResponse<CategoryDataModel[]>> {
    const req: ICategoryRequest = {
      sort_code: 0,
      top_n: top,
      entity_code: 3,
    };
    const url = HOMEPAGE_API;
    return axios.post(url, req);
  },
  getConditions(top: number): Promise<AxiosResponse<CategoryDataModel[]>> {
    const req: ICategoryRequest = {
      sort_code: 0,
      top_n: top,
      entity_code: 2,
    };
    const url = HOMEPAGE_API;
    return axios.post(url, req);
  },
  getScenes(top: number): Promise<AxiosResponse<CategoryDataModel[]>> {
    const req: ICategoryRequest = {
      sort_code: 0,
      top_n: top,
      entity_code: 4,
    };
    const url = HOMEPAGE_API;
    return axios.post(url, req);
  },
};
